(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3col-text-image"] && !window.DesignMode) return;
  try {
    

  var pics = document.getElementById("featured-blogs");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".blog-column").addClass("fadeinstatic");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-deana"] && !window.DesignMode) return;
  try {
    


var pics = document.getElementById("about-deana");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".pic").addClass("fadein");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["branding-projects"] && !window.DesignMode) return;
  try {
    


if ($('.menu-sticky').length > 0) {

    var loadedClass = $('.menu-sticky li').first().attr('class');
    $('.menu-sticky li').first().addClass('active'); 
    

    $('.branding-projects .image-container .image').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.menu-sticky li').on('mouseenter', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.menu-sticky li').removeClass('active');
            $(this).toggleClass('active');


            $('.branding-projects .image-container .image').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["building-materials"] && !window.DesignMode) return;
  try {
    

 


$('.building-materials .col-left li').eq(0).addClass('active');
  $('.building-materials .material-description').eq(0).addClass('show');
  $('.building-materials .outline-button').eq(0).addClass('show');

    $('.building-materials .col-left li').on('mouseover', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.building-materials .col-left li').removeClass('active');
          $('.building-materials .material-description').removeClass('show');
          $('.building-materials .outline-button').removeClass('show');
            $(this).toggleClass('active');


           $('.building-materials .material-description').each(function() {
                var crrnt = $(this);
                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }
                else {
                    crrnt.removeClass('show');
                }
            });

          


        }
    });
 
    


  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care"] && !window.DesignMode) return;
  try {
    


if ($('.customer-care-menu').length > 0) {
    
    var loadedClass = $('.customer-care-menu li').attr('class');
    $('.customer-care-menu li').eq(0).addClass('active');      

    $('.customer-care .right .menu-section').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.customer-care-menu li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.customer-care-menu li').removeClass('active');
            $(this).toggleClass('active');


            $('.customer-care .right .menu-section').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-screen"] && !window.DesignMode) return;
  try {
    


setTimeout(() => {
  $(function() {
  $('.fade-in-screen').addClass('loaded'); 
});
}, 1000);

setTimeout(() => {
  $(function() {
  $('.fade-in-screen img').addClass('fadeout'); 
});
}, 1000);

setTimeout(() => {
  $(function() {
  $('.fade-in-screen').addClass('void');
});
}, 4000);




$('.showroom-enter').hover(
       function(){ $('.showroom-image').toggleClass('show') }
)

$('.studio-enter').hover(
       function(){ $('.studio-image').toggleClass('show') }
)



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    

    $( document ).ready(function() {
    $(".main-blog .pic").addClass("fadeinstatic");
});

   


    $('.blog-filter-menu .mobile-filter').click(function() {
    $('.blog-filter-menu ul').toggleClass('open');
  });

    
    if ($('.blog-filter-menu').length > 0) {

    var loadedClass = $('.blog-filter-menu li').last().attr('class');
    $('.blog-filter-menu li').last().addClass('active'); 
    

    $('.project').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

      $('.featured-blog').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });



      

    $('.blog-filter-menu li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.blog-filter-menu li').removeClass('active');
            $(this).toggleClass('active');

          


            $('.project').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                  
                  
                }

                else {
                    crrnt.removeClass('show');
                }
            });	

          
if ($('.project.show').hasClass(clickedClass)) {
            $('.project.show').first().addClass('full-width'); 
          }
          


          $('.featured-blog').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }

 

    

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

$('.mobile-filter-open').on('click', function() {
  $('.mobile-filter-menu').toggleClass('show');
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-signup"] && !window.DesignMode) return;
  try {
    

  var pics = document.getElementById("new-coll-signup");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".pic").addClass("fadein");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["podcast-giving-back"] && !window.DesignMode) return;
  try {
    

  var pics = document.getElementById("podcast-giving-back");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".image-wrapper").addClass("fadein");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-hero"] && !window.DesignMode) return;
  try {
    

$(document).ready(function() {
		$(".hero-right").addClass("fadeinstatic");
	});







  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projects-blog"] && !window.DesignMode) return;
  try {
    


if ($('.menu-sticky').length > 0) {

    var loadedClass = $('.menu-sticky li').first().attr('class');
    $('.menu-sticky li').first().addClass('active'); 
    

    $('.projects-blog .image-container .image').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.menu-sticky li').on('mouseenter', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.menu-sticky li').removeClass('active');
            $(this).toggleClass('active');


            $('.projects-blog .image-container .image').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-process"] && !window.DesignMode) return;
  try {
    

   $( document ).ready(function() { 



    var loadedClass = $('.step-menu li').first().attr('class');
    $('.step-menu li').first().addClass('active'); 
    

    $('.step-description p').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	



    $('.step-menu li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.step-menu li').removeClass('active');
            $(this).toggleClass('active');

          


            $('.step-description p').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                  
                  
                }

                else {
                    crrnt.removeClass('show');
                }
            });	

          
        }
    });
  


     
   });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom-ethos"] && !window.DesignMode) return;
  try {
    

  var pics = document.getElementById("showroom-ethos");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".columns-container").addClass("fadeinstatic");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom-materials"] && !window.DesignMode) return;
  try {
    

  var pics = document.getElementById("showroom-materials");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".image-wrapper").addClass("fadein");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom-studio"] && !window.DesignMode) return;
  try {
    

  var pics = document.getElementById("showroom-studio");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".left-col").addClass("fadein");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-hero"] && !window.DesignMode) return;
  try {
    

  var pics = document.getElementById("studio-hero");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".logo-image").addClass("fadein");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-showroom-section"] && !window.DesignMode) return;
  try {
    

  var pics = document.getElementById("showroom-section");

var height,
		half;

window.addEventListener("resize", adjustHeightVars);
window.addEventListener("scroll", fadeBox);

function fadeBox () {	
	var x = pics.offsetTop - half;
	var y = window.pageYOffset;
	if (y >= x) {
		$(".pic").addClass("fadein");
	}
}

function adjustHeightVars() {
	height = window.innerHeight;
	half = height * 0.35;
}

adjustHeightVars();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !window.DesignMode) return;
  try {
    

  $("#Next").click(function(){
	$("#testimonials-slider").append($("#testimonials-slider .item-container:first-of-type"));
});

$("#Prev").click(function(){
	$("#testimonials-slider").prepend($("#testimonials-slider .item-container:last-of-type"));
});

  } catch(e) { console.error(e); }
})();
})();
